<script>
import Avatar from '@/components/common/Avatar.vue'
import ImageCropperModal from '@/components/modal/ImageCropperModal.vue';
import ImageSourceSelectorModal from '@/components/modal/ImageSourceSelectorModal.vue';
import service from './../services/HomeService'
import { ToggleButton } from 'vue-js-toggle-button'
import i18n from '@/plugins/i18n'
import BaseComponent from '../../../mixins/BaseComponent';
export default {
   name: 'HomeUserInfo',
   components: { Avatar,  ImageCropperModal, ImageSourceSelectorModal, ToggleButton},
   mixins: [BaseComponent],
   props: {
      activeFTTH: {
         type: Boolean,
         default: false
      },
      user: {
         type: Object,
         default: () => ({
            name: '',
            phone: '',
            avatarUrl: '',
            avatar:'',
         })
      },
      isLinkedFTTH: {
         type: Boolean,
         default: false
      },
      isShowMainAccountButton: {
         type: Boolean,
         default: false
      }
   },
   data() {
      return {
         image: null,
         primaryColor: 'var(--bs-primary)',
         showAccount: false,
         imagePath: null,
         
      }
   },
   
   methods: {
      maskNumber(numberString) {
         if (!numberString) return ''
         return numberString.slice(0, -3).replace(/\d/g, '• ') + numberString.slice(-3)
      },
      async handleOpenSourceImage(source) {
         console.log('source: '+ source)
         if (source.toLowerCase() == 'library' || source.toLowerCase() == 'thư viện' || source.toLowerCase() == 'ຫົວຂໍ້ຫນັງສື' || source.toLowerCase() == '库')
         return this.$refs.imageInputRef.click()
          else {
            return this.$refs.cameraRef.click()
         }
      },
      chooseImage() {
         this.$refs.sourceModalRef?.showModal()
      },
      onFileChange(event) {
         const maxFileSize = 1024 * 1024 * 1024 //1GB
         const file = event.target.files[0]
         if (file && file.type.startsWith('image/')) {
            if(file.size >= maxFileSize){
               alert(`${i18n.t('avatar.max_file_size_mess')}`)
               event.target.value = ""// Clear the file input
               return
            }
            const reader = new FileReader()
            reader.onload = (e) => {
               this.image = e.target.result // Set the image URL for cropper
               this.$refs.modalRef?.showModal()
            }
            reader.readAsDataURL(file) // Read the file as base64 URL
         } else {
            alert('Please select a valid image file')
         }
      },
      onCancelImage() {
         this.image = null;
         this.$refs.imageInputRef.value = null;
      },
      onChange({value}) {
          this.$emit('show-account', value)
      },
      async onSave(img) {
         try {
            this.showLoading()
            const formData = {
               // isdn: "2095144190",
               // language: "en",
               imageBase64 : img
            }
          const {wsResponse} = await service.UpdateAvatar(formData)
          this.imagePath = wsResponse
           this.onCancelImage()
         } catch (error) {
            console.error(error)
         }finally {
            this.hideLoading()
         }
      }
   },
   emits: ['onClickFunction', 'redirectTo']
}
</script>

<template>
   <div class="w-100 d-flex justify-content-between">
      <ImageCropperModal ref="modalRef" :image="image" @cancel="onCancelImage" @save="onSave" />
      <ImageSourceSelectorModal ref="sourceModalRef" @select-source="handleOpenSourceImage" />
      <div class="nav-home__info">
         <div class="avatar__wrapper" @click="chooseImage()">
            <avatar :size="60" :src="this.imagePath ?? user.avatar" :text="user.name" alt="avatar" />
            <button class="button button--upload" type="button">
               <img src="@/assets/images/ic-camera.jpg" alt="" />
            </button>
            <input
               ref="imageInputRef"
               class="d-none"
               type="file"
               @change="onFileChange"
               accept="image/*"
            />
            <input
               ref="cameraRef"
               class="d-none"
               type="file"
               @change="onFileChange"
               accept="image/*"
               capture="user"
            />
         </div>

         <div>
            <div class="nav-home__info__name">{{ user.name }}</div>
            <div
               v-show="user.phone"
               class="nav-home__info__phone"
               @click="$emit('redirectTo', '/mobile/info?tab=user')"
            >
               {{ user.phone }}
            </div>
         </div>
      </div>
      <div
         v-if="!activeFTTH || isLinkedFTTH"
      >
         <div class="nav-home__action"  @click="$emit('onClickFunction', activeFTTH ? '/ftth/service' : '/mobile/info?tab=account')">
            <span>{{ $t('home.view_detail') }}</span>
            <span><img alt="img" src="@/assets/images/ic-narrow-right.svg" /></span>
         </div>
         <template v-if="isShowMainAccountButton">
            <div class="nav-home__main-account" v-show="!activeFTTH">
               <toggle-button 
               id="toggleButton"
               ref="toggleButton"
               :v-model="showAccount"
               @change="onChange"
               :width="100"
               :color="{checked: primaryColor, unchecked: '#fff' }"
               :switch-color="{checked: '#fff', unchecked: '#ccc' }"
               :labels="{checked: $t('mobile.home.main_account'), unchecked: $t('mobile.home.main_account')}"
               />
            </div>
         </template>
        
      </div>
   </div>
</template>

<style lang="scss" scoped>
.nav-home {
   &__menu,
   &__search {
      cursor: pointer;
   }

   &__info {
      display: flex;
      gap: 10px;
      align-items: center;

      &__name {
         font-size: 16px;
         font-weight: 600;
         color: var(--bs-white);
         margin-bottom: 10px;
         line-height: 20px;
      }

      &__phone {
         background: var(--bs-white);
         border-radius: 100px;
         height: 30px;
         display: inline-flex;
         gap: 10px;
         align-items: center;
         padding: 0 15px;
         cursor: pointer;
      }
   }

   &__action {
      color: var(--bs-white);
      font-size: 15px;
      font-weight: 600;
      display: flex;
      align-items: center;
      gap: 6px;
      cursor: pointer;
      text-transform: capitalize;

      img {
         width: 10px;
         height: 10px;
      }
   }
   &__main-account {
      margin-top: 10px;

      ::v-deep .v-switch-core{
         box-shadow: 0px 0px 30px 0px #FFFFFF;

      }

      ::v-deep .v-switch-label {
         text-transform: capitalize;
         &.v-right {
            color: var(--bs-primary);
         }
        
      }
   }
}
.avatar__wrapper {
   position: relative;
   cursor: pointer;
   .button--upload {
      position: absolute;
      bottom: 0;
      right: 0;
      padding: 2px;
      background-color: #fff;
      border-color: #fff;
      img {
         margin: 0;
         width: 12px;
         height: 12px;
      }
   }
}
</style>
